import classNames from 'classnames';
import React from 'react';
import Background from 'images/firstview/background.png';
import PcImg from 'images/firstview/pc.png';
import Style from 'styles/components/first_view.module.scss';


const FirstView = () => {
  return (
  <div className = {classNames(Style.firstView)}>
    <img className = {classNames(Style.firstView__background)} src={Background} alt="" />
    <div className = {classNames(Style.firstView__overLay)}>
      <div className = {classNames(Style.firstView__overLay__text)}>
        もう諦めなくていい。<br />
        "できた！"を増やしながら<br />
        自分もショップも一緒に成長<br />
      </div>
      <img className = {classNames(Style.firstView__overLay__img)} src={PcImg} alt="" />
    </div>
  </div>
  )
};

export default FirstView;
